// Follow-Up Ternary Tree — API wrappers.
import { _apiGet, _apiPost } from "../../lib/apiClient";

export const apiTreeGet         = () => _apiGet("/followuptree");
export const apiTreeGetNode     = (id) => _apiGet(`/followuptree/node/${id}`);
export const apiTreeInit        = (memberId) => _apiPost("/followuptree/init", memberId ? { memberId } : {});
export const apiTreeCreateNode  = (parentNodeId) => _apiPost("/followuptree/nodes", { parentNodeId });
export const apiTreeAssign      = (nodeId, memberId) => _apiPost("/followuptree/assign", { nodeId, memberId });
export const apiTreeRemove      = (nodeId, departureReason, departureNotes) =>
  _apiPost("/followuptree/remove", { nodeId, departureReason, departureNotes: departureNotes || null });
export const apiTreeReassign    = (fromNodeId, toNodeId) => _apiPost("/followuptree/reassign", { fromNodeId, toNodeId });
export const apiTreeLookupSlot  = (slotRef) => _apiGet(`/followuptree/lookup/slot/${encodeURIComponent(slotRef)}`);
export const apiTreeLookupMember= (memberNumber) => _apiGet(`/followuptree/lookup/member/${encodeURIComponent(memberNumber)}`);
export const apiTreeOrphaned    = () => _apiGet("/followuptree/orphaned");

export const apiDelReqCreate    = (targetType, targetId, reason) =>
  _apiPost("/followuptree/deletion-request", { targetType, targetId, reason });
export const apiDelReqList      = () => _apiGet("/followuptree/deletion-requests");
export const apiDelReqApprove   = (id) => _apiPost(`/followuptree/deletion-request/${id}/approve`, { approve: true });
export const apiDelReqDeny      = (id, reason) => _apiPost(`/followuptree/deletion-request/${id}/deny`, { approve: false, reason });

export const apiMigrateMemberNumbers = () => _apiPost("/admin/migrate-member-numbers", {});

// Phase 5 — Follow-Up logging & activity
export const apiTreeLog          = (body) => _apiPost("/followuptree/log", body);
export const apiTreeLogQuick     = (body) => _apiPost("/followuptree/log-quick", body);
export const apiTreeActivity     = (limit = 20, offset = 0) =>
  _apiGet(`/followuptree/activity?limit=${limit}&offset=${offset}`);
export const apiTreeHistory      = (nodeId) => _apiGet(`/followuptree/history/${encodeURIComponent(nodeId)}`);
export const apiTreeAttention    = () => _apiGet("/followuptree/attention");
export const apiTreeDashboard    = () => _apiGet("/followuptree/dashboard-stats");
export const apiTreeHealthMap    = () => _apiGet("/followuptree/health-map");
export const apiTreeNotifySup    = (nodeId, reason) =>
  _apiPost("/followuptree/notify-supervisor", { nodeId, reason: reason || null });
export const apiSlotHistory      = (nodeId) => _apiGet(`/followuptree/slot-history/${encodeURIComponent(nodeId)}`);
export const apiMemberHistory    = (memberId) => _apiGet(`/followuptree/member-history/${encodeURIComponent(memberId)}`);
export const apiVisitorJourney   = (memberId) => _apiGet(`/members/${encodeURIComponent(memberId)}/visitor-journey`);
export const apiLockStatus       = () => _apiGet("/admin/member-number-lock-status");
export const apiLockMemberNumbers = () => _apiPost("/admin/lock-member-numbers", {});
export const apiReassignBulk     = (swaps) => _apiPost("/followuptree/reassign-bulk", { swaps });
export const apiTemporarilyVisible = (memberId, days) =>
  _apiPost(`/members/${encodeURIComponent(memberId)}/temporarily-visible`, { days: days || null });

export const FOLLOWUP_METHODS = ["In-person", "Phone Call", "Video Call", "Written Message"];
export const FOLLOWUP_STATUS_UPDATES = ["No Change", "Active", "Needs Attention", "Inactive"];

export const DEPARTURE_REASONS = [
  "Relocated",
  "Passed Away",
  "Personal Decision",
  "Transferred to Another Church",
  "Removed or Disciplinary",
  "Unknown",
  "Other",
];
